import { useEffect } from 'react';
import useSessionId from '../../../../../flows/src/hooks/useSessionId';
import {
  setInsuranceCompanies,
  setTerminationLetterModal,
} from '../../../store/redux/slices/offersSlice';
import { loadSelectionState } from '../../../store/redux/slices/selectionSlice';
import { useLouiseDispatch } from '../../../store/redux/store';
import { getAvailableInsuranceCompanies } from '../api/getAvailableInsuranceCompanies';

const useInitialOffersPageData = () => {
  const sessionId = useSessionId();
  const louiseDispatch = useLouiseDispatch();

  useEffect(() => {
    initial();
  }, []);

  const getAllAvailableInsuranceCompanies = async () => {
    const data = await getAvailableInsuranceCompanies();
    const mappedInsuranceCompanies = data.items.map(
      ({ insurance_company }) => insurance_company,
    );
    louiseDispatch(setInsuranceCompanies(mappedInsuranceCompanies));
  };

  /**
   * Do initial stuff before offers can be shown
   */
  const initial = async () => {
    await getAllAvailableInsuranceCompanies();
    louiseDispatch(setTerminationLetterModal(''));
    await louiseDispatch(loadSelectionState(sessionId));
  };
};

export default useInitialOffersPageData;
